<template>
  <div class="appInfoRoot">
    <div class="linkInfoPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />

      <div v-else class="linkInfoPage__layout resourceFormPage__layout">
        <div class="resourceFormPage__headerDock">
          <header class="resourceFormPage__actionBar">
            <div class="resourceFormPage__lead">
              <h1 class="resourceFormPage__pageTitle">查看应用</h1>
              <span v-if="platformLabel" class="resourceFormPage__typeReadonly">
                {{ platformLabel }}
              </span>
            </div>
            <div class="resourceFormPage__actions">
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--ghost"
                @click="goBack"
              >
                返回列表
              </button>
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--primary"
                v-check-role
                @click="goEdit"
              >
                编辑
              </button>
            </div>
          </header>
        </div>

        <main class="linkInfoPage__main resourceFormPage__main main appFormPage__main">
          <el-card class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">基本信息</strong>
            </div>
            <div class="linkInfoBasic">
              <div class="linkInfoBasic__preview">
                <el-image
                  v-if="info.icon"
                  class="linkInfoPreview__img"
                  :src="info.icon"
                  :preview-src-list="[info.icon]"
                  fit="cover"
                >
                  <div slot="error" class="linkInfoPreview__empty">
                    <i class="el-icon-mobile-phone" aria-hidden="true" />
                    <span>加载失败</span>
                  </div>
                </el-image>
                <div v-else class="linkInfoPreview__empty">
                  <i class="el-icon-mobile-phone" aria-hidden="true" />
                  <span>暂无 Icon</span>
                </div>
              </div>

              <div class="linkInfoBasic__body">
                <h1 class="linkInfoBasic__name">{{ info.appName || '—' }}</h1>
                <div class="linkInfoBasic__keyRow">
                  <span class="linkInfoBasic__keyLabel">appKey</span>
                  <code class="linkInfoBasic__keyValue link-font-mono">{{ info.appKey || '—' }}</code>
                </div>
                <div class="linkInfoBasic__grid">
                  <div class="linkInfoBasic__field">
                    <span class="linkInfoBasic__fieldLabel">返回图片格式</span>
                    <span class="linkInfoBasic__fieldValue">{{
                      getPictureFormatLabel(info.pictureFormat)
                    }}</span>
                  </div>
                  <div class="linkInfoBasic__field">
                    <span class="linkInfoBasic__fieldLabel">平台</span>
                    <span class="linkInfoBasic__fieldValue">{{ platformLabel }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-card>

          <el-card class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">域名配置</strong>
            </div>
            <!-- appInfoPairRow：查看页两列并排；样式在 appFormPage.css，避免共用 grid 被盖掉 -->
            <div class="appInfoPairRow">
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">domainName</span>
                <code class="linkInfoBasic__fieldValue link-font-mono">{{
                  info.domainName || '—'
                }}</code>
              </div>
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">cdnPrefix</span>
                <code class="linkInfoBasic__fieldValue link-font-mono">{{
                  info.cdnPrefix || '—'
                }}</code>
              </div>
            </div>
          </el-card>

          <el-card class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">包名</strong>
            </div>
            <div v-if="visiblePackageList.length" class="appPackageList">
              <span
                v-for="(item, index) in visiblePackageList"
                :key="`${index}-${item}`"
                class="appPackageList__item"
              >
                {{ item }}
              </span>
            </div>
            <p v-else class="appInfoEmpty">—</p>
          </el-card>

          <el-card class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">商店与数据集</strong>
            </div>
            <div class="appInfoPairRow">
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">商店链接</span>
                <span class="linkInfoBasic__fieldValue">{{ info.storeLink || '—' }}</span>
              </div>
              <div class="linkInfoBasic__field">
                <span class="linkInfoBasic__fieldLabel">数据集字段</span>
                <div v-if="info.dynamicTags.length" class="appDatasetTags">
                  <span
                    v-for="tag in info.dynamicTags"
                    :key="tag"
                    class="appDatasetTags__pill"
                  >
                    {{ tag }}
                  </span>
                </div>
                <p v-else class="appInfoEmpty">—</p>
              </div>
            </div>
          </el-card>

          <el-card v-if="info.desc" class="card linkInfoSection">
            <div slot="header">
              <strong class="linkInfoSection__title">备注</strong>
            </div>
            <p class="appInfoComment">{{ info.desc }}</p>
          </el-card>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppById } from '../../../api/appManage'
import { mapAppDetailToForm } from './appFormConstants'
import { getPictureFormatLabel, getPlatformLabel } from './appListHelpers'

export default {
  name: 'AppManageInfo',
  data() {
    return {
      info: mapAppDetailToForm({}),
      loading: false,
    }
  },
  computed: {
    platformLabel() {
      return getPlatformLabel(this.info.platform)
    },
    visiblePackageList() {
      return (this.info.packageList || []).filter((item) => String(item || '').trim())
    },
  },
  created() {
    this.loadAppDetail()
  },
  methods: {
    getPictureFormatLabel,
    loadAppDetail() {
      this.loading = true
      getAppById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.info = mapAppDetailToForm(res.data)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    goBack() {
      this.$router.push('/channel/app/list')
    },
    goEdit() {
      this.$router.push(`/channel/app/edit/${this.$route.params.id}`)
    },
  },
}
</script>

<style scoped>
.appInfoRoot,
.fullContainer {
  height: 100%;
}
</style>

<style>
.collectionModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.collectionModule .main {
  background: transparent;
}
</style>
